import React from "react";
import {
  FaLinkedinIn,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Footer = () => {
  const socialLinks = [
    {
      icon: <FaLinkedinIn />,
      link: "https://www.linkedin.com/company/job-zam/",
      label: "LinkedIn",
    },
    {
      icon: <FaInstagram />,
      link: "https://www.instagram.com/job_zam/",
      label: "Instagram",
    },
    {
      icon: <FaFacebookF />,
      link: "https://www.facebook.com/profile.php?id=61585822228982",
      label: "Facebook",
    },
    {
      icon: <FaYoutube />,
      link: "https://www.youtube.com/@JobZam",
      label: "YouTube",
    },
  ];

  return (
    <footer className="backdrop-blur-lg bg-white/40 text-sm text-gray-700 px-4 py-8 border-t border-white/20 shadow-inner">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">

        {/* Social Media Section */}
        <div className="flex flex-col items-center md:items-start gap-3">
          <p className="font-semibold text-gray-800">Follow JobZam</p>

          <div className="flex space-x-5">
            {socialLinks.map((item, idx) => (
              <motion.a
                key={idx}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.label}
                whileHover={{ scale: 1.2 }}
                className="text-blue-600 hover:text-purple-500 transition text-lg"
              >
                {item.icon}
              </motion.a>
            ))}
          </div>
        </div>

        {/* Footer Links */}
        <div className="flex flex-wrap justify-center md:justify-end gap-6 text-sm font-medium">
          <Link to="/about" className="hover:text-blue-600 transition">
            About
          </Link>
          <Link to="/contact" className="hover:text-blue-600 transition">
            Contact
          </Link>
          <Link to="/faq" className="hover:text-blue-600 transition">
            FAQ
          </Link>
          <Link to="/privacy" className="hover:text-blue-600 transition">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-blue-600 transition">
            Terms & Conditions
          </Link>
        </div>
      </div>

      {/* Divider */}
      <div className="mt-8 border-t border-gray-200 pt-6">

        {/* Copyright */}
        <p className="text-center text-gray-500 text-xs leading-relaxed">
          © {new Date().getFullYear()}{" "}
          <span className="font-semibold text-gray-700">JobZam®</span>. All rights reserved.
          <br />
          JobZam® is a registered UK trademark (UK00004249682).
        </p>
      </div>
    </footer>
  );
};

export default Footer;
